import React, { useState, useEffect } from "react";
import DataGrid, { Column,Export } from "devextreme-react/data-grid";
import Button1 from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { api_path } from "../../shared.js";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver-es";
import { exportDataGrid } from "devextreme/excel_exporter";
import swal from "sweetalert";
function CustomerCampaignDatagrid(props) {
  const token = process.env.REACT_APP_API_TOKEN;
  const url = `${api_path}/customer/customers.php?campaign_id=${props.CAMPAIGN_ID}`;

  const customerDataStore = createStore({
    key: "CRM_CUSCODE",
    loadUrl: url,
    reshapeOnPush: true,
    onBeforeSend(method, ajaxOptions) {
      ajaxOptions.crossDomain = true;
      ajaxOptions.xhrFields = { withCredentials: true };
      ajaxOptions.headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
    },
  });
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false); // state สำหรับระหว่างเรียก API
  // โหลดข้อมูลจาก store
  useEffect(() => {
    customerDataStore.load().then((data) => {
      setGridData(data);
      setLoading(false);
    });
  }, [props.CAMPAIGN_ID]);
  const handleDeliverCampaign = async () => {
    try {
      setUpdating(true); // เริ่ม loading

      const payload = {
        campaign_id: props.CAMPAIGN_ID,
        action: "deliver",
      };

      // ✅ ดูค่าที่ React จะส่งไป
      console.log("📤 Sending to API:", payload);

      const response = await fetch(
        `${api_path}/customer/update-customer-campaign.php`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      // ✅ ดู raw response ที่ได้จาก PHP
      const text = await response.text();
      console.log("📥 Raw response from PHP:", text);

      // ✅ แปลงเป็น JSON ถ้าเป็น JSON ได้
      let result;
      try {
        result = JSON.parse(text);
      } catch {
        console.error("❌ Response is not valid JSON:", text);
        swal("Error", "Server returned invalid JSON.", "error");
        return;
      }

      console.log("✅ Parsed JSON result:", result);

      if (response.ok && result.status === "success") {
        swal("Done", "Campaign delivered successfully!", "success");
        const data = await customerDataStore.load();
        setGridData(data);
      } else {
        alert(`Error: ${result.message || "Update failed"}`);
      }
    } catch (error) {
      console.error("❌ Fetch error:", error);
      swal("Error", "An error occurred while updating campaign.", "error");
    } finally {
      setUpdating(false);
    }
  };

  // ปุ่ม enable ถ้า campaign status = 0
  const isButtonDisabled = props.CAMPAIGN_STATUS !== 0;

  if (loading) return <p>Loading...</p>; // แสดง Loading ระหว่างดึงข้อมูล

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Main sheet");

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        // ใช้ template string ถูกต้อง
        const fileName = `CustomerCampaign_${props.CAMPAIGN_ID}.xlsx`;
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          fileName
        );
      });
    });
  };

  return (
    <Grid container spacing={2}>
      {gridData.length > 0 && (
        <Grid item xs={12} sm={12}>
          <DataGrid
            dataSource={gridData} // ใช้ข้อมูลจาก state เลย
            keyExpr="CRM_CUSCODE"
            showBorders={true}
            onExporting={onExporting}
            rowAlternationEnabled={true}
            columnAutoWidth={true}
            searchPanel={{ visible: false }}
            filterRow={{ visible: true }}
          >
            <Column dataField="CRM_CUSCODE" caption="CRM CODE" />
            <Column dataField="CUSTOMER_NAME" caption="NAME" />
            <Column dataField="TAX_ID" caption="TAX_ID" />
            <Column dataField="CUSTOMER_STATUS_EN" caption="STAGE" />
            <Column dataField="CUSTOMER_TYPE_EN" caption="TYPE" />
            <Column dataField="SALES_NAME" caption="SALES" />
              <Export enabled={true} allowExportSelectedData={true} />
          </DataGrid>
        </Grid>
      )}

      {gridData.length > 0 && (
        <Grid item xs={12} sm={12}>
          <Button1
            variant="contained"
            color="primary"
            //disabled={isButtonDisabled} // disable ถ้า status ไม่ใช่ 0
            onClick={handleDeliverCampaign}
          >
            {updating ? "Updating..." : "Deliver Campaign"}
          </Button1>
        </Grid>
      )}
    </Grid>
  );
}

export default CustomerCampaignDatagrid;
